import React from "react";

const TableFilter = ({ filterCallback, filter }) => {
  return (
    <div className="filter">
      <label>
        <input
          type="checkbox"
          checked={filter?.warOnly}
          onChange={() =>
            filterCallback({ ...filter, warOnly: !filter.warOnly })
          }
        />{" "}
        War days only
      </label>
      <div>Sort:</div>
      <select
        value={filter.sort}
        onChange={(event) =>
          filterCallback({ ...filter, sort: event.target.value })
        }
      >
        <option value="trophies">Trophies</option>
        <option value="role">Role</option>
        <option value="thLevel">TH Level</option>
        <option value="expLevel">Exp Level</option>
        <option value="donations">Donated</option>
        <option value="donationsReceived">Received</option>
      </select>
    </div>
  );
};

export default TableFilter;
